import React from 'react'
import {TextField, Grid} from '@material-ui/core';
import '../App.css';
import { useStyles } from '../Components/useStyles';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
  import DateFnsUtils from '@date-io/date-fns';
  import 'date-fns';

export default function StudentIDPage({setPupulNo,studentID,setApplicantFirstName, setApplicantDOB, applicantDOB,
    applicantLastName, applicantFirstName, setApplicantLastName}) {
    const classes = useStyles();
    const [errorState, setErrorState] = React.useState(false);
    const [errorFirstNameState, setErrorFirstNameState] = React.useState(false);
    const [errorLastNameState, setErrorLastNameState] = React.useState(false);
    const regexpName = /^$|^[-A-Za-z ]+$/;

    let firstName = applicantFirstName;
    let lastName = applicantLastName;

    function handleBlur(number) {        
        if((number === 0 || number === null)) {
            setErrorState(true);
            setPupulNo(number); 
        }
        else if(number !== studentID){
            setPupulNo(number);           
        }            
    }    
    function handleDateChange(date) {
        if(date !== null && !isNaN(date.getTime()))
            setApplicantDOB(date.toDateString());
        else if(date === null)
            setApplicantDOB(null);            
    }
    function handleFirstNameBlur(firstname){
        if(firstname === '') {
            setErrorFirstNameState(true);
            firstName = firstname;
        }           

        setApplicantFirstName(firstname);
    }
    function handleLastNameBlur(lastname){
        if(lastname === ''){
            setErrorLastNameState(true);
            lastName = lastname;
        }
            
        setApplicantLastName(lastname);
    }
    
    return(
        <>  
            <h1 className='Title2-settings'>Please provide the student's 7-digit Pupil number.</h1>

            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField required id="txt_studentid" label="Pupil Number" defaultValue={studentID === 0 ? null: studentID} error={errorState} helperText={errorState ? 'Student\'s Pupil Number is empty' : ' '}
                        className={classes.FulltextField} margin="normal" variant="outlined" fullWidth={true} onBlur={event=>handleBlur(event.target.value)} inputProps={{maxLength: 7}}
                    /> 
                </Grid>
                <Grid item xs={6}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>           
                        <KeyboardDatePicker variant="inline" format="MM/dd/yyyy" margin="normal" id="date_studentDOB" label="Date of Birth"
                            value={applicantDOB} fullWidth={true} KeyboardButtonProps={{ 'aria-label': 'change date',}} maxDate={new Date()} maxDateMessage={"Student\'s birth date can not be in the future"}
                            className={classes.FulltextField} inputVariant="outlined" disableFuture={true} onChange={handleDateChange} emptyLabel="mm/dd/yyyy"
                    />
                    </MuiPickersUtilsProvider>              
                </Grid>

            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField required id="txt_studentFirstName" label="Student First Name" defaultValue={applicantFirstName} error={errorFirstNameState || !regexpName.test(firstName)} helperText={errorFirstNameState ? 'Student\’s first name is empty' : !regexpName.test(firstName) ? 'Student\'s first name must be in English characters.' : ''}
                        className={classes.FulltextField} margin="normal" variant="outlined" fullWidth={true} onBlur={event=>handleFirstNameBlur(event.target.value)}
                    /> 
                </Grid>
                <Grid item xs={6}>
                    <TextField required id="txt_studentLastName" label="Student Last Name" defaultValue={applicantLastName} error={errorLastNameState || !regexpName.test(lastName)} helperText={errorLastNameState ? 'Student\’s last name is empty' : !regexpName.test(lastName) ? 'Student\'s last name must be in English characters' : ''}
                        className={classes.FulltextField} margin="normal" variant="outlined" fullWidth={true} onBlur={event=>handleLastNameBlur(event.target.value)}
                    /> 
                </Grid>
            </Grid>
        </>
    );
}
